function reveal() {
    var reveals = document.querySelectorAll(".reveal");
    var lazyElements = document.querySelectorAll(".lazy");
  
    for (var i = 0; i < reveals.length; i++) {
      var windowHeight = window.innerHeight;
      var elementTop = reveals[i].getBoundingClientRect().top;
      var elementVisible = 150;
  
      if (elementTop < windowHeight - elementVisible) {
        reveals[i].classList.add("active");
      }/* else {
        reveals[i].classList.remove("active");
      }*/
    }

    // Handle lazy elements for three-blocks-guaranteed animation
    for (var j = 0; j < lazyElements.length; j++) {
      var windowHeight = window.innerHeight;
      var elementTop = lazyElements[j].getBoundingClientRect().top;
      var elementVisible = 150;
  
      if (elementTop < windowHeight - elementVisible) {
        lazyElements[j].classList.add("entered");
      }
    }
}

// Trigger reveal on page load
document.addEventListener("DOMContentLoaded", reveal);
window.addEventListener("scroll", reveal);